import { ReportResultProps } from '@app/core/reports/types';
import { ReportResult } from '../quality-result/ReportResult';
import { useSyncViewStore } from '../store/useSyncViewStore';
import { StreamQualityReport } from './types';

/**
 * Renders the stream quality timeline/table and syncs view store when a new report is loaded.
 */
export function StreamQualityReportResult(props: ReportResultProps<StreamQualityReport>) {
  const { result } = props;
  useSyncViewStore(result.data.from, result.data.to);
  return <ReportResult report={result} />;
}
